"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSortOptionArray = exports.isSortOption = exports.ValidSortOptions = void 0;
const Util_1 = require("./Util");
// Per PMC,
// "possible values are: name (alphabetical), -name (reverse-alphabetical), or a string including 'relevance' "
//
// https://support.kyruus.com/hc/en-us/articles/360000060363-Sorting-Search-Results-for-Providers
exports.ValidSortOptions = [
    'relevance',
    'availability_density_best',
    'availability_soonest',
    'name',
    'networks',
    'rating',
    'distance'
];
const isSortOption = (option) => exports.ValidSortOptions.includes(option);
exports.isSortOption = isSortOption;
exports.isSortOptionArray = (0, Util_1.predicateArrayOn)(exports.isSortOption);
//# sourceMappingURL=SortOption.js.map